<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCliente" role="form" method="post" autocomplete="off" onSubmit="return false">

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<label class="form-label">Actividad</label>
							<input type="text" v-model="objEvento.Evento" class="form-control" maxlength="300" placeholder="Nombre de la Actividad">
							<CValidation v-if="this.errorvalidacion.Evento" :Mensaje="'*'+errorvalidacion.Evento[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Fecha Evento</label>
							<div class="calendar">
								<Datepicker v-model="objEvento.FechaEvento" @input="ValidarFechas('FE')" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00" ref="FE"></Datepicker>
								<CValidation v-if="this.errorvalidacion.FechaEvento" :Mensaje="'*'+errorvalidacion.FechaEvento[0]"/>
							</div>
						</div>

						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Hora Evento</label>
							<div class="clock">
								<vue-clock-picker v-model="objEvento.HoraEvento" @input="ValidarFechas('HE')" :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'" placeholder="00:00"></vue-clock-picker>
								<CValidation v-if="this.errorvalidacion.HoraEvento" :Mensaje="'*'+errorvalidacion.HoraEvento[0]"/>
							</div>
						</div>

						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Fecha Montaje</label>
							<div class="calendar">
								<Datepicker v-model="objEvento.FechaMontaje" @input="ValidarFechas('FM')" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00" ref="FM"></Datepicker>
								<CValidation v-if="this.errorvalidacion.FechaMontaje" :Mensaje="'*'+errorvalidacion.FechaMontaje[0]"/>
							</div>
						</div>

						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Hora Montaje</label>
							<div class="clock">
								<vue-clock-picker v-model="objEvento.HoraMontaje" @input="ValidarFechas('HM')" :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'" placeholder="00:00"></vue-clock-picker>
								<CValidation v-if="this.errorvalidacion.HoraMontaje" :Mensaje="'*'+errorvalidacion.HoraMontaje[0]"/>
							</div>
						</div>

						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Fecha Desmontaje</label>
							<div class="calendar">
								<Datepicker v-model="objEvento.FechaDesmontaje" @input="ValidarFechas('FD')" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00" ref="FD"></Datepicker>
								<CValidation v-if="this.errorvalidacion.FechaDesmontaje" :Mensaje="'*'+errorvalidacion.FechaDesmontaje[0]"/>
							</div>
						</div>								

						<div class="col-6 col-sm-6 col-md-4 col-lg-2">
							<label class="form-label">Hora Desmontaje</label>
							<div class="clock">
								<vue-clock-picker v-model="objEvento.HoraDesMontaje" @input="ValidarFechas('HD')" :input-class="'form-control'" :done-text="'Listo'" :cancel-text="'Cancelar'" placeholder="00:00"></vue-clock-picker>
								<CValidation v-if="this.errorvalidacion.HoraDesMontaje" :Mensaje="'*'+errorvalidacion.HoraDesMontaje[0]"/>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6">
							<label class="form-label">Locación</label>
							<input type="text" v-model="objEvento.Locacion" class="form-control" placeholder="Ingresar Locación" maxlength="250">
							<CValidation v-if="this.errorvalidacion.Locacion" :Mensaje="'*'+errorvalidacion.Locacion[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6">
							<label class="form-label">Back Up</label>
							<input type="text" v-model="objEvento.BackUp" class="form-control" placeholder="Ingresar Back Up" maxlength="250">
							<CValidation v-if="this.errorvalidacion.BackUp" :Mensaje="'*'+errorvalidacion.BackUp[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
							<label class="form-label">Descripción</label>
							<textarea v-model="objEvento.Descripcion" class="form-control" placeholder="Ingresar Descripción" rows="2"></textarea>
						</div>
					</div>

					<hr class="horizontal dark">

					<div class="row sticky">
						<div class="col-12 text-end">
							<button :disabled="objEvento.FechaEvento==''" type="button" @click="AbrirModalGaleria();" class="btn btn-primary mb-1 mr-1">
								<i class="fas fa-images"></i> Galería
							</button>

							<button type="button" @click="AbrirModalImagen();" class="btn btn-primary mb-1 mr-1">
								<i class="fas fa-camera"></i> Agregar Imágen
							</button>

							<button type="button" @click="AbrirModalDescripcion();" class="btn btn-primary mb-1 mr-1">
								<i class="fas fa-layer-plus"></i> Agregar Elemento
							</button>

							<button type="button" @click="AbrirModalPaquete();" class="btn btn-primary mb-1">
								<i class="fas fa-box-full"></i> Paquetes
							</button>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<nav>
								<div class="nav nav-tabs" id="nav-tab" role="tablist">
									<button type="button" class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">
										Elementos <i class="fas fa-boxes"></i>
									</button>

									<button type="button" class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">
										Paquetes <i class="fas fa-box-full"></i>
									</button>
								</div>
							</nav>

							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
									<div class="row pt-2">
										<div class="col-12 col-sm-12 col-md-12 col-lg-12">
											<div class="table-responsive pb-0">
												<table class="table mb-0">
													<thead>
														<tr>
															<th class="text-green-black text-xxs font-weight-bolder opacity-7">
																#
															</th>
															<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Imagen</th>
															<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Descripción</th>
															<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7"></th>
															<th class="text-uppercase text-end text-green-black text-xxs font-weight-bolder opacity-7">Total</th>
															<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7"></th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item, index) in objEvento.Elementos" :key="index">
															<td class="align-middle text-center" style="width: 10px;">
																<h6 class="mb-0 text-sm text-capitalize ps-3">{{(index+1)}}</h6>
															</td>
															<td class="align-middle text-center" style="width: 120px;">
																<span v-if="item.Anexado != 1">
																	<span v-if="!item.Nomimagen">
																		<img src="@/assets/style/image/sin_imagen_180.jpg" class="img-fluid rounded">
																	</span>

																	<span v-else>
																		<img :src="RutaFile+item.UrlImagen+item.Nomimagen" class="img-fluid rounded">
																	</span>
																</span>

																<span v-else>
																	<span v-if="item.IdDetalleCotizacion>0">
																		<img :src="RutaAnexada+item.UrlImagen+item.Nomimagen" class="img-fluid rounded">
																	</span>
																	<span v-else>
																		<img :src="RutaTemporal+item.UrlImagen+item.Nomimagen" class="img-fluid rounded">
																	</span>
																</span>
															</td>
															<td class="align-middle ps-3">
																
																<div class="btn-group mb-0" role="group" aria-label="basic">
																	<button type="button" :id="'itbe'+index" @click="GetEstiloCampoAct(item,'ESP');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloEsp, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloEsp}">
																		<i class="far fa-language"></i> Español
																	</button>

																	<button type="button" :id="'itbi'+index" @click="GetEstiloCampoAct(item,'ING');" :class="{'btn btn-sm btn-outline-primary mb-0' : item.EstiloIng, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloIng}">
																		<i class="far fa-language"></i> Inglés
																	</button>

																	<button type="button" :id="'itbn'+index" @click="GetEstiloCampoAct(item,'NOT');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloNot, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloNot}">
																		<i class="fas fa-sticky-note"></i> Notas
																	</button>
																</div>
																
																<textarea v-show="item.EstiloEsp" v-model="item.Descripcion" class="form-control mt-1" rows="2"></textarea>
																<textarea v-show="item.EstiloIng" v-model="item.DescripcionIngles" class="form-control mt-1" rows="2"></textarea>
																<textarea v-show="item.EstiloNot" v-model="item.Notas" class="form-control mt-1" rows="2"></textarea>
															</td>
															<td>
																<div class="row mb-1">
																	<label class="col-sm-4 col-form-label text-sm mx-0">QTY</label>
																	<div class="col-sm-8">
																		<input type="text" v-model="item.Cantidad" @input="$onlyNums($event,item,'Cantidad');Calcular(item);" class="form-control form-control-sm">
																	</div>
																</div>

																<div class="row mb-1">
																	<label class="col-sm-4 col-form-label text-sm mx-0">{{item.TipoMoneda}} $</label>
																	<div class="col-sm-8">
																		<input type="text" v-model="item.Precio" @input="$number_decimal($event,item,'Precio');Calcular(item);" class="form-control form-control-sm">
																	</div>
																</div>

																<div class="row mb-1">
																	<label class="col-sm-4 col-form-label text-sm mx-0">MONEDA</label>
																	<div class="col-sm-8">
																		<select v-model="item.TipoMoneda" class="form-select form-select-sm">
																			<option value="MXN">MXN</option>
																			<option value="USD">USD</option>
																		</select>
																	</div>
																</div>
															</td>
															<td class="align-middle text-end text-sm">
																<p class="text-xs text-secondary mb-0">
																	$ {{item.TotalIndividual}}
																</p>
															</td>
															<td class="align-middle text-end text-sm">
																<button type="button" @click="EliminarItemDetalle(index)" class="btn btn-link text-danger text-gradient px-1 mb-0">
																	<i class="far fa-trash-alt me-2" aria-hidden="true"></i>
																	Eliminar
																</button>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>

								<div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
									<div v-for="(paq, indexPaq) in objEvento.Paquetes" :key="indexPaq">
										<div class="row pt-2">
											<div class="col-12 col-sm-12 col-md-12 col-lg-12">
												<div class="table-responsive pb-0">
													<table class="table mb-0">
														<thead>
															<tr>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Nombre</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Imagen</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Descripción</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Precio</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Acción</th>
															</tr>
														</thead>
														<tbody>
															<tr>
																<td class="align-middle text-center" style="width: 10px;">
																	<h6 class="mb-0 text-sm text-capitalize ps-3">{{(paq.Nombre)}}</h6>
																</td>
																<td class="align-middle text-center" style="width: 120px;">
																	<span v-if="paq.Anexado != 1">
																		<span v-if="!paq.Imagen">
																			<img src="@/assets/style/image/sin_imagen_180.jpg" class="img-fluid rounded">
																		</span>
	
																		<span v-else>
																			<img :src="RutaFile+paq.UrlImagen+paq.Imagen" class="img-fluid rounded">
																		</span>
																	</span>
	
																	<span v-else>
																		<span v-if="paq.IdDetalleCotizacion>0">
																			<img :src="paq.UrlImagen+paq.Imagen" class="img-fluid rounded">
																		</span>
																		<span v-else>
																			<img :src="paq.UrlImagen+paq.Imagen" class="img-fluid rounded">
																		</span>
																	</span>
																</td>
																<td class="align-middle ps-3">
																	<div class="btn-group mb-0" role="group" aria-label="basic">
																		<button type="button" id="PaqDescEsp" @click="GetEstiloCampoPaq(indexPaq, 'ESP');" :class="{'btn btn-sm btn-outline-primary mb-0' :paq.EstiloEsp, 'btn btn-sm btn-primary btn-nav-group mb-0' :!paq.EstiloEsp}">
																			<i class="far fa-language"></i> Español
																		</button>
	
																		<button type="button" id="PaqDescEng" @click="GetEstiloCampoPaq(indexPaq, 'ING');" :class="{'btn btn-sm btn-outline-primary mb-0' : paq.EstiloIng, 'btn btn-sm btn-primary btn-nav-group mb-0' :!paq.EstiloIng}">
																			<i class="far fa-language"></i> Inglés
																		</button>
																	</div>
																	<textarea v-show="paq.EstiloEsp" v-model="paq.Descripcion" class="form-control mt-1" rows="2"></textarea>
																	<textarea v-show="paq.EstiloIng" v-model="paq.DescripcionIng" class="form-control mt-1" rows="2"></textarea>
																</td>
																<td>
																	<div class="row mx-0 mb-1">
																		<label class="col-4 col-form-label text-sm mx-0">Cantidad</label>
																		<div class="col-8">
																			<input type="text" :value="paq.Cantidad" readonly class="form-control form-control-sm">
																		</div>
																	</div>
																	<div class="row mx-0">
																		<label class="col-4 col-form-label text-sm mx-0">Precio</label>
																		<div class="col-sm-8">
																			<input type="text" :value="$formatNumber(paq.Precio, '$')" readonly class="form-control form-control-sm">
																		</div>
																	</div>
																</td>
																<td class="align-middle text-left text-sm">
																	<button type="button" @click="EliminarPaquete(indexPaq)" class="btn btn-link text-danger text-gradient px-1 mb-0">
																		<i class="far fa-trash-alt me-2" aria-hidden="true"></i>
																		Eliminar
																	</button>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<div class="row pt-2">
											<div class="col-12 col-sm-12 col-md-12 col-lg-12">
												<div class="table-responsive pb-0">
													<table class="table mb-0">
														<thead>
															<tr>
																<th class="text-green-black text-xxs font-weight-bolder opacity-7">#</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Imagen</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Descripción</th>
																<th class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">Precio</th>
																<th class="text-uppercase text-end text-green-black text-xxs font-weight-bolder opacity-7">Total</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="(item, index) in paq.ListaElementos" :key="index">
																<td class="align-middle text-center" style="width: 10px;">
																	<h6 class="mb-0 text-sm text-capitalize ps-3">{{(index+1)}}</h6>
																</td>
																<td class="align-middle text-center" style="width: 120px;">
																	<span v-if="item.IdCotizacionEventoPaqueteDetalle && item.Anexado != 1">
																		<span v-if="!item.Imagen">
																			<img src="@/assets/style/image/sin_imagen_180.jpg" class="img-fluid rounded">
																		</span>

																		<span v-else>
																			<img :src="RutaFile + item.UrlImagen + item.Imagen" class="img-fluid rounded">
																		</span>
																	</span>

																	<span v-else>
																		<span v-if="!item.Imagen">
																		<img src="@/assets/style/image/sin_imagen_180.jpg"
																				class="img-fluid rounded">
																		</span>

																		<span v-else>
																			<img :src="RutaFile + item.UrlImagen + item.Imagen"
																				class="img-fluid rounded">
																		</span>
																	</span>
																</td>
																<td class="align-middle ps-3">
																	
																	<div class="btn-group mb-0" role="group" aria-label="basic">
																		<button type="button" :id="'itbe'+index" @click="GetEstiloCampoAct(item,'ESP');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloEsp, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloEsp}">
																			<i class="far fa-language"></i> Español
																		</button>
	
																		<button type="button" :id="'itbi'+index" @click="GetEstiloCampoAct(item,'ING');" :class="{'btn btn-sm btn-outline-primary mb-0' : item.EstiloIng, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloIng}">
																			<i class="far fa-language"></i> Inglés
																		</button>
	
																		<button type="button" :id="'itbn'+index" @click="GetEstiloCampoAct(item,'NOT');" :class="{'btn btn-sm btn-outline-primary mb-0' :item.EstiloNot, 'btn btn-sm btn-primary btn-nav-group mb-0' :!item.EstiloNot}">
																			<i class="fas fa-sticky-note"></i> Notas
																		</button>
																	</div>
																	
																	<textarea v-show="item.EstiloEsp" v-model="item.Descripcion" class="form-control mt-1" rows="2"></textarea>
																	<textarea v-show="item.EstiloIng" v-model="item.DescripcionIng" class="form-control mt-1" rows="2"></textarea>
																	<textarea v-show="item.EstiloNot" v-model="item.Notas" class="form-control mt-1" rows="2"></textarea>
																</td>
																<td>
																	<div class="row mb-1">
																		<label class="col-sm-4 col-form-label text-sm mx-0">Cantidad</label>
																		<div class="col-sm-8">
																			<input type="text" :value="item.Cantidad" readonly class="form-control form-control-sm">
																		</div>
																	</div>
	
																	<div class="row mb-1">
																		<label class="col-sm-4 col-form-label text-sm mx-0">Precio</label>
																		<div class="col-sm-8">
																			<input type="text" :value="$formatNumber(item.Precio, '$')" readonly class="form-control form-control-sm">
																		</div>
																	</div>
																</td>
																<td class="align-middle text-end text-sm">
																	<p class="text-xs text-secondary mb-0">
																		{{$formatNumber(item.PrecioTotal ? item.PrecioTotal : 0, '$')}}
																	</p>
																</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<CValidation v-if="this.errorvalidacion.Elementos" :Mensaje="'*'+errorvalidacion.Elementos[0]"/>

							<hr class="horizontal dark">
							<div class="row justify-content-end">
								<div class="col-12 col-sm-12 col-md-5 col-lg-6">
									<table class="table">
										<thead>
											<tr>
												<th></th>
												<th class="text-end px-1">Paquetes</th>
												<th class="text-end px-1">Elementos</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td class="text-end text-green-black">Sub total:</td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{ objEvento.SubTotalPqt }}</p></td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{objEvento.SubTotal}}</p></td>
											</tr>
											<tr>
												<td class="text-end text-green-black">16%IVA:</td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{ objEvento.SubTotalIvaPqt }}</p></td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{objEvento.SubTotalIva}}</p></td>
											</tr>
											<tr>
												<td class="text-end text-green-black">Total:</td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{ objEvento.TotalGrupalPqt }}</p></td>
												<td class="text-end"><p class="text-sm font-weight-bold mb-0">$ {{objEvento.TotalGrupal}}</p></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

						</div>
					</div>
						
				</form>

				<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
					<template slot="Form">
						<Form :poBtnSave="oBtnSave" :pFechaEvento="objEvento.FechaEvento"></Form>
					</template>
					<template slot="BtnExtraModal">
						<button type="button" v-show="VistaGaleria" @click="EjecutaVistaGal(0)" class="btn btn-success mr-1">
							<i class="fa fa-eye"></i> Ver Detalle
						</button>

						<button type="button" v-show="!VistaGaleria" @click="EjecutaVistaGal(1)" class="btn btn-success mr-1">
							<i class="fa fa-arrow-left"></i> Regresar
						</button>
					</template>
				</CModal>

				<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
					<template slot="Form">
						<Form2 :poBtnSave="oBtnSave2"></Form2>
					</template>
				</CModal>

				<CModal :pConfigModal="ConfigModal3" :poBtnSave="oBtnSave3">
					<template slot="Form">
						<Form3 :poBtnSave="oBtnSave3"></Form3>
					</template>
					<template slot="BtnExtraModal">
						<button type="button" @click="EjecutaOtro();" class="btn btn-info mr-1">
							<i class="fa fa-plus-circle"></i> Otro
						</button>
					</template>
					
				</CModal>

				<CModal :pConfigModal="ConfigModal4" :poBtnSave="oBtnSave4">
					<template slot="Form">
						<Form4 :poBtnSave="oBtnSave4"></Form4>
					</template>
					<template slot="BtnExtraModal">
						<button type="button" v-show="VistaPaquete" @click="EjecutaVistaPaq(0)" class="btn btn-success mr-1">
							<i class="fa fa-eye"></i> Ver elementos
						</button>

						<button type="button" v-show="!VistaPaquete" @click="EjecutaVistaPaq(1)" class="btn btn-success mr-1">
							<i class="fa fa-arrow-left"></i> Regresar
						</button>
					</template>
				</CModal>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Calendar from '@/helpers/StaticComboBox.js';
import Configs from '@/helpers/VarConfig.js';

import Form from '@/views/modulos/crm/modalAcciones/FormGaleria.vue';
import Form2 from '@/views/modulos/crm/modalAcciones/FormImagen.vue';
import Form3 from '@/views/modulos/crm/modalAcciones/FormDescripcion.vue';
import Form4 from '@/views/modulos/crm/modalAcciones/FormPaquete.vue';

import moment from 'moment';
const EmitEjecuta = 'seccionGaleria';
const EmitEjecuta2 = 'seccionImagen';
const EmitEjecuta3 = 'seccionDescripcion';
const EmitEjecuta4 = 'seccionPaquete';

export default {
    name: 'FormActividad',
    props: ['poBtnSave'],
    components:{
		Form,
		Form2,
		Form3,
		Form4,
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			ConfigModal:{
                ModalTitle: "Galeria",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'xl',
				//ShowFooter: false,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
				TxtBtnSave: 'Añadir',
				ShowBtnCancel: false,
				ShowBtnSave: false,
            },
			ConfigModal2:{
                ModalTitle: "Cargar Imagen",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg'
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
			ConfigModal3:{
                ModalTitle: "Elemento Sin Imagen",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'xl'
            },
            oBtnSave3: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
			ConfigModal4:{
                ModalTitle: "Paquetes",
                ModalNameId: 'ModalForm4',
                EmitSeccion: EmitEjecuta4,
                ModalSize: 'xl'
            },
            oBtnSave4: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
				ShowBtnCancel: false,
				TxtBtnSave: 'Seleccionar',
                EmitSeccion: EmitEjecuta4,
            },
			objEvento: {
				IdCotizacion: 0,
				IdCotizacionEvento: 0,
				Evento: '',
				FechaEvento: '',
				FechaMontaje: '',
				FechaDesmontaje: '',
				HoraEvento: '',
				HoraMontaje: '',
				HoraDesMontaje: '',
				Locacion: '',
				BackUp: '',
				Descripcion: '',
				Iva: 0,
				SubTotalIva: 0,
				SubTotal: 0,
				TotalGrupal: 0,
				IvaPqt: 0,
				SubTotalIvaPqt: 0,
				SubTotalPqt: 0,
				TotalGrupalPqt: 0,
				Elementos: [],
				Paquetes: [],
				PaquetesEliminados: [],
				EliminarDetalles: [],
				BorrarImagenesTemp: [],
			},
			ListaElementosPaquete: [],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			timezone: '',
			VistaGaleria: true,
			VistaPaquete: true,
			Setpicker: Calendar.calendarSettings,
			RutaFile: '',
			RutaAnexada: '',
			RutaTemporal: '',
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			let errores = 0;
			let msg = 'El campo es requerido';
			let ms2 = 'Debe agregar al menos un elemento';
			let objError = {};

			if(this.objEvento.Evento == '')			{ objError.Evento 			= [msg]; errores++;	}
			if(this.objEvento.FechaEvento == '')	{ objError.FechaEvento 		= [msg]; errores++;	}
			if(this.objEvento.HoraEvento == '')		{ objError.HoraEvento 		= [msg]; errores++;	}
			if(this.objEvento.FechaMontaje == '')	{ objError.FechaMontaje 	= [msg]; errores++;	}
			if(this.objEvento.HoraMontaje == '')	{ objError.HoraMontaje 		= [msg]; errores++;	}
			if(this.objEvento.FechaDesmontaje == ''){ objError.FechaDesmontaje	= [msg]; errores++;	}
			if(this.objEvento.HoraDesMontaje == '')	{ objError.HoraDesMontaje 	= [msg]; errores++;	}
			if(this.objEvento.Locacion == '')		{ objError.Locacion 		= [msg]; errores++;	}
			if(this.objEvento.BackUp == '')			{ objError.BackUp 			= [msg]; errores++;	}
			if(this.objEvento.Elementos.length == 0){ objError.Elementos		= [ms2]; errores++;	}
			

			if(errores>0)
			{
				this.errorvalidacion = objError;
				this.poBtnSave.DisableBtn = false;
				this.$toast.warning('Complete los campos obligatorios');
				return false;
			}

			let band1 = 0;
            let msg1 = '';

			$.each(this.objEvento.Elementos, function(key, value){
                if(value.Descripcion == ''){
                    msg1 = "El campo Descripción en español de la partida: "+(key+1)+" no puede estar vacío.";
                    band1++;
                    return false;
                }
                else if(value.DescripcionIngles == ''){
                    msg1 = "El campo Descripción en inglés de la partida: "+(key+1)+" no puede estar vacío.";
                    band1++;
                    return false;
                }
                else if(value.Cantidad == ''){
                    msg1 = "El campo Cantidad de la partida: "+(key+1)+" no puede estar vacío.";
                    band1++;
                    return false;
                }
                else if(value.Precio == ''){
                    msg1 = "El campo Precio de la partida: "+(key+1)+" no puede estar vacío.";
                    band1++;
                    return false;
                }
            });

			// VALIDACIÓN PAQUETES 
			this.objEvento.Paquetes.some((paquete, index) => {
				if (paquete.Descripcion.trim() === '' || paquete.DescripcionIng.trim() === '') {
					msg1 = "El campo Descripción en español/inglés del Paquete: "+ (index + 1 )+" no puede estar vacío.";
					band1++;
					return true; 
				}
				// VALIDACIÓN ELEMENTOS DEL PAQUETE
				let hasEmptyFields = false;
				paquete.ListaElementos.some((elem, index2) => {
					if (elem.Descripcion.trim() === '' || elem.DescripcionIng.trim() === '') {
						msg1 = "El campo Descripción en español/inglés en los elementos del paquete en la partida: "+ (index2 + 1 )+" no puede estar vacío.";
						band1++;
						hasEmptyFields = true;
						return true;
					}
				})
				return hasEmptyFields;
			})

            if(band1>0){ this.$toast.warning(msg1); this.poBtnSave.DisableBtn = false; return false; }

			if(this.objEvento.FechaEvento!=''){
				this.objEvento.FechaEvento = moment(this.objEvento.FechaEvento).format('YYYY-MM-DD');
			}
			if(this.objEvento.FechaMontaje!=''){
				this.objEvento.FechaMontaje = moment(this.objEvento.FechaMontaje).format('YYYY-MM-DD');
			}
			if(this.objEvento.FechaDesmontaje!=''){
				this.objEvento.FechaDesmontaje = moment(this.objEvento.FechaDesmontaje).format('YYYY-MM-DD');
			}


			if(this.objEvento.IdCotizacion == 0)
			{
				this.poBtnSave.DisableBtn = false;  
				this.bus.$emit('SetearEvento',this.objEvento);
				this.bus.$emit('CloseModal_'+this.Emit);
			}
			else
			{
				/* if(this.objEvento.IdCotzEvento == 0) {
					await this.$http.post(
						'clientes',this.objEvento
					).then((res)=>{
						this.EjecutaConExito(res);
					}).catch(err=>{   
						this.EjecutaConError(err);
					});
				} else {
					await this.$http.put(
						'clientes/'+this.objEvento.IdCotzEvento,
						this.objEvento
					).then((res)=>{                 
						this.EjecutaConExito(res);
					}).catch(err=>{   
						this.EjecutaConError(err);
					});
				} */
				this.poBtnSave.DisableBtn = false;  
				this.bus.$emit('SetearEvento',this.objEvento);
				this.bus.$emit('CloseModal_'+this.Emit);
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "clientes/"+this.objCliente.IdCliente
            ).then((res) => {
                this.objCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCliente.Fecha.replace(/-/g,'\/');
                this.objCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objEvento = {
				IdCotizacion: 0,
				IdCotizacionEvento: 0,
				Evento: '',
				FechaEvento: '',
				FechaMontaje: '',
				FechaDesmontaje: '',
				HoraEvento: '',
				HoraMontaje: '',
				HoraDesMontaje: '',
				Locacion: '',
				BackUp: '',
				Descripcion: '',
				Iva: 0,
				SubTotalIva: 0,
				SubTotal: 0,
				TotalGrupal: 0,
				IvaPqt: 0,
				SubTotalIvaPqt: 0,
				SubTotalPqt: 0,
				TotalGrupalPqt: 0,
				Elementos: [],
				Paquetes: [],
				PaquetesEliminados: [],
				EliminarDetalles: [],
				BorrarImagenesTemp: [],
			};

            this.errorvalidacion = [];
        },
		AbrirModalGaleria()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta,0);
		},
		AbrirModalImagen()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta2,0);
		},
		AbrirModalDescripcion()
		{
			this.bus.$emit('NewModal_'+EmitEjecuta3,0);
		},
		AbrirModalPaquete()
		{
			this.bus.$emit('NewModal_' + EmitEjecuta4, this.objEvento);
		},
		EliminarItemDetalle(index)
		{
			let item = this.objEvento.Elementos[index];

			if(item.IdDetalleCotizacion>0)
			{
				this.$swal(Configs.configEliminar).then((result) =>
				{
					if(result.value)
					{
						let objImg = {
							IdDetalle: item.IdDetalleCotizacion
						};
						// SE COLOCAN LOS ELEMENTOS PARA ELIMINAR
						this.objEvento.EliminarDetalles.push(objImg);
						this.EjecutaDelete(item,index);
					}
				});
			}
			else
			{
				this.EjecutaDelete(item,index);
			}
		},
		EjecutaDelete(item,index)
		{
			// SE ELIMINA LAS IMAGENES ANEXADAS
			if(item.Anexado == 1 && item.IdDetalleCotizacion == 0)
			{
				let objBorrar = {
					Nomimagen: item.Nomimagen,
					UrlImagen: item.UrlImagen,
					IdDetalle: item.IdDetalleCotizacion,
				};
				this.objEvento.BorrarImagenesTemp.push(objBorrar);
			}

			this.objEvento.Elementos.splice(index, 1);
			this.EjecutarCalculos();
		},
		EjecutaOtro(){
			this.bus.$emit('AgregarFilaDescripcion');
		},
		EjecutaVistaGal(valor)
		{
			if(valor == 0){
				this.VistaGaleria = false;
			}
			else{
				this.VistaGaleria = true;
			}
			this.bus.$emit('CambiarVistaGal');
		},
		EjecutaVistaPaq(valor) {
			this.bus.$emit('CambiarVistaPaq');
		},
		GetEstiloCampoAct(item,Campo)
        {
            let EsA = false;
            let EsB = false;
            let EsC = false;

            switch(Campo)
            {
                case 'ESP':
                    EsA = true;
                break;

                case 'ING':
                    EsB = true;
                break;

                case 'NOT':
                    EsC = true;
                break;
            }

			item.EstiloEsp = EsA;
			item.EstiloIng = EsB;
			item.EstiloNot = EsC;
        },
		GetEstiloCampoPaq(index, idioma){
			this.objEvento.Paquetes[index].EstiloEsp = idioma === 'ESP';
			this.objEvento.Paquetes[index].EstiloIng = idioma === 'ING';
			this.objEvento = structuredClone(this.objEvento)
		},
		/*GetEstiloCampoAct(index,Campo)
        {
			//let class1 = 'btn btn-sm btn-outline-primary mb-0';
			let class1 = 'btn btn-sm btn-danger mb-0';
			let class2 = 'btn btn-sm btn-primary mb-0';

            let EsA = class2;
            let EsB = class2;
            let EsC = class2;

			document.getElementById('itbe'+index).removeAttribute('class');
			document.getElementById('itbi'+index).removeAttribute('class');
			document.getElementById('itbn'+index).removeAttribute('class');

            switch(Campo)
            {
                case 'ESP': EsA = class1; break;
                case 'ING': EsB = class1; break;
                case 'NOT': EsC = class1; break;
            }

			document.getElementById('itbe'+index).setAttribute('class',EsA);
			document.getElementById('itbi'+index).setAttribute('class',EsB);
			document.getElementById('itbn'+index).setAttribute('class',EsC);
        },*/
		Calcular(item)
		{
			let valor = this.CalcularImporteUnitario(item);
			item = valor;

			this.EjecutarCalculos();
		},
		CalcularImporteUnitario(item)
        {
            let Elemento = item;
            let Precio = (isNaN(Elemento.Precio)) ? 0 : Elemento.Precio;
            let Cantidad = (isNaN(Elemento.Cantidad)) ? 0 : Elemento.Cantidad;
            let Total = parseFloat(Precio)*parseFloat(Cantidad);
            Total = (isNaN(Total) ? 0 : Total);

            Elemento.TotalIndividual = parseFloat(Total).toFixed(2);

			return Elemento;

        },
        EjecutarCalculos()
        {
            let Total = 0;
            let SubTotal = 0;
            let Arreglo = this.objEvento.Elementos;
            let Iva = 0.16;
           

            for(let i=0; i<Arreglo.length; i++)
            {
                let Cantidad = Arreglo[i].Cantidad;
                let PrecioUn = Arreglo[i].Precio;

                Cantidad = (isNaN(Cantidad)) ? 0 : parseFloat(Cantidad);
                PrecioUn = (isNaN(PrecioUn)) ? 0 : parseFloat(PrecioUn);

                SubTotal+= parseFloat(Cantidad*PrecioUn);
            }

            SubTotal = (isNaN(SubTotal)) ? 0 : SubTotal;
            Iva = parseFloat(SubTotal)*parseFloat(Iva);
            Iva = (isNaN(Iva)) ? 0 : Iva;
            Total = parseFloat(SubTotal)+parseFloat(Iva);

			this.objEvento.Iva 			= 16;
            this.objEvento.SubTotal 	= parseFloat(SubTotal).toFixed(2);
            this.objEvento.SubTotalIva 	= parseFloat(Iva).toFixed(2);
            this.objEvento.TotalGrupal	= parseFloat(Total).toFixed(2);
        },
		EjecutarCalculosPaquete() {
            const IVA = 0.16;
			let subTotal = 0;
			let ivaTotal = 0;
			let total = 0;
			
			subTotal = this.objEvento.Paquetes.reduce((acc, current) => {
				current =  isNaN(parseFloat(current.Precio)) ? 0 : parseFloat(current.Precio);
				return parseFloat(acc + current);
			},0);
			ivaTotal = parseFloat(subTotal * IVA);
			total = parseFloat(subTotal + ivaTotal);

			this.objEvento.SubTotalPqt 		= parseFloat(subTotal).toFixed(2);
            this.objEvento.SubTotalIvaPqt 	= parseFloat(ivaTotal).toFixed(2);
            this.objEvento.TotalGrupalPqt	= parseFloat(total).toFixed(2);
		},
		ValidarFechas(cmp)
		{
			let FechaEvento = this.objEvento.FechaEvento;
			let FechaMontaje = this.objEvento.FechaMontaje;
			let FechaDesMont = this.objEvento.FechaDesmontaje;

			let HoraEvento = this.objEvento.HoraEvento;
			let HoraMontaje = this.objEvento.HoraMontaje;
			let HoraDesMont = this.objEvento.HoraDesMontaje;

			if(FechaEvento!='')
			{
				let FechaTransform = moment(FechaEvento).format('YYYY-MM-DD');
				let valuesStart = FechaTransform.split("-");
				FechaEvento = new Date(valuesStart[0],(valuesStart[1]-1),valuesStart[2]);

				if(HoraEvento!=''){
					HoraEvento = new Date(FechaTransform+' '+HoraEvento+':00');
				}
			}
			if(FechaMontaje!='')
			{
				let FechaTransform = moment(FechaMontaje).format('YYYY-MM-DD');
				let valuesStart = FechaTransform.split("-");
				FechaMontaje = new Date(valuesStart[0],(valuesStart[1]-1),valuesStart[2]);

				if(HoraMontaje!=''){
					HoraMontaje = new Date(FechaTransform+' '+HoraMontaje+':00');
				}
			}
			if(FechaDesMont!='')
			{
				let FechaTransform = moment(FechaDesMont).format('YYYY-MM-DD');
				let valuesStart = FechaTransform.split("-");
				FechaDesMont = new Date(valuesStart[0],(valuesStart[1]-1),valuesStart[2]);

				if(HoraDesMont!=''){
					HoraDesMont = new Date(FechaTransform+' '+HoraDesMont+':00');
				}
			}

			// SI LA FECHA DE MONTAJE ES MAYOR QUE LA DEL EVENTO MARCA ERROR
			if((FechaEvento !='' && FechaMontaje!='') && (FechaMontaje>FechaEvento))
			{
				this.$toast.warning('La fecha de montaje no puede ser mayor a la fecha del evento');
				if(cmp == 'FE'){
					this.objEvento.FechaEvento = '';
					this.$refs.FE.clearDate();
				}else{
					this.objEvento.FechaMontaje = '';
					this.$refs.FM.clearDate()
				}
				return false;
			}
			// SI LA FECHA DE DESMONTAJE ES MENOR QUE LA DEL EVENTO MARCA ERROR
			if((FechaEvento !='' && FechaDesMont!='') && (FechaEvento>FechaDesMont))
			{
				this.$toast.warning('La fecha de desmontaje no puede ser menor a la fecha del evento');
				if(cmp == 'FE'){
					this.objEvento.FechaEvento = '';
					this.$refs.FE.clearDate();
				}else{
					this.objEvento.FechaDesmontaje = '';
					this.$refs.FD.clearDate();
				}
				return false;
			}

			if((FechaEvento !='' && FechaMontaje!='') || (FechaEvento !='' && FechaDesMont!=''))
			{
				if(HoraEvento!='' && HoraMontaje!='')
				{
					if(HoraMontaje>=HoraEvento)
					{
						this.$toast.warning('La hora de montaje debe ser menor a la hora del evento');
						this.objEvento.HoraMontaje = '';
						return false;
					}
				}

				if(HoraEvento!='' && HoraDesMont!='')
				{
					if(HoraEvento>=HoraDesMont)
					{
						this.$toast.warning('La hora del evento debe ser menor a la hora del desmontaje');
						this.objEvento.HoraDesMontaje = '';
						return false;
					}
				}
			}
		},
		GetUlrRutas()
		{
			this.$http.get(
                "solicitudGetRutas/"
            ).then((res) => {
                this.RutaFile = res.data.RutaGaleria;
                this.RutaAnexada = res.data.RutaAnexada;
                this.RutaTemporal = res.data.RutaTemporal;

            }).finally(()=>{
            });
		},
		AgregarPaquetes(ListaPaquetes) {
			ListaPaquetes.forEach(paq => {
				paq.EstiloEsp = true;
				paq.EstiloIng = false;
				paq.SubTotal = paq.Precio;
				paq.SubTotalIva = paq.Precio * 0.16;
				paq.TotalGrupal = paq.Precio * 1.16
			})
			this.objEvento.Paquetes = ListaPaquetes;
			this.bus.$emit('CloseModal_' + EmitEjecuta4);
			this.EjecutarCalculosPaquete();
		},
		EliminarPaquete(index) {
			// SI EL PAQUETE YA EXISTIA EN LA DB, SE AGREGA EN PAQUETES ELIMNNADOS
			if (this.objEvento.Paquetes[index].IdCotizacionEventoPaquete > 0) {
				this.$swal(Configs.configEliminar).then((result) => {
					if(result.value)  {
						this.objEvento.PaquetesEliminados.push({
							IdCotizacionEventoPaquete: this.objEvento.Paquetes[index].IdCotizacionEventoPaquete,
						});
						this.objEvento.Paquetes.splice(index, 1);
						this.EjecutarCalculosPaquete();
					}
				})
			} else {
				this.objEvento.Paquetes.splice(index, 1);
				this.EjecutarCalculosPaquete();
			}
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(objCot,item)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,() =>
            {
                this.Guardar();
            });
            this.Limpiar();

			this.GetUlrRutas();

			
            // SE COMPRUEBA QUE TENGA ELEMENTOS
            if (Object.keys(item).length !== 0) 
            {
				let nuevoObj = JSON.stringify(item);
				this.objEvento = JSON.parse(nuevoObj);
				//this.objEvento = //item;
                //this.objCliente.IdCliente = Id;
                //this.Recuperar();
				this.ConfigLoad.ShowLoader = false;
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }

			this.objEvento.IdCotizacion = objCot.IdCotizacion
			this.bus.$off('SetearGaleria');
			this.bus.$on('SetearGaleria',(obj)=>
			{
				console.log(obj);
				let arreglo = this.objEvento.Elementos;
				obj.forEach((element)=>{
					let item = this.CalcularImporteUnitario(element);
					arreglo.push(item);
				});

				this.EjecutarCalculos();
			});

			this.bus.$off('SetearImagen');
			this.bus.$on('SetearImagen',(obj)=>
			{
				console.log(obj);
				let element = this.CalcularImporteUnitario(obj);

				this.objEvento.Elementos.push(element);
				this.EjecutarCalculos();
			});

			this.bus.$off('SetearDescripcion');
			this.bus.$on('SetearDescripcion',(obj)=>
			{
				console.log(obj);
				let arreglo = this.objEvento.Elementos;
				obj.forEach((element)=>{
					let item = this.CalcularImporteUnitario(element);
					arreglo.push(item);
				});

				this.EjecutarCalculos();
			});
			this.EjecutarCalculosPaquete();
			this.bus.$off('ResetearVistaGal');
			this.bus.$on('ResetearVistaGal',()=>
			{
				this.VistaGaleria = true;
			});
			this.bus.$off('HabilitarBtbVerElems');
			this.bus.$on('HabilitarBtbVerElems', (isSelected) => this.VistaPaquete = isSelected);

			this.bus.$off('EnviarPaquete');
			this.bus.$on('EnviarPaquete', (ListaPaquetes) => this.AgregarPaquetes(ListaPaquetes));
			
        });
    }
}
</script>
